import { useState } from 'react';

export const useFormValidation = (validationSchema) => {
  const [errors, setErrors] = useState({});

  const validate = (body, returnOnly = false) => {
    let { error } = validationSchema.validate(body, { abortEarly: false });
    if (error) {
      const validationErrors = {};
      error.details.forEach((detail) => {
        validationErrors[detail.context.key] = detail.message;
      });
      if (!returnOnly) setErrors(validationErrors);
      return false;
    } else {
      setErrors({});
      return true;
    }
  };

  return { errors, setErrors, validate };
};
